<template>
  <v-container v-if="activeImage" no-gutters>
    <v-row>
      <v-col v-if="images.length > 0" cols="3">
        <div v-for="image in images" :key="image.alt" class="pb-3" @click="activeImage = image">
          <v-img :src="image.url" :class="image !== activeImage ? 'inactive-image':''"/>
        </div>
      </v-col>
      <v-col :cols="images.length > 0 ? '9' : '12'">
        <v-img :src="activeImage.url"/>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  props: {
    images: {
      type: Array,
      default: () => ([]),
    },
  },
  data: () => ({
    activeImage: null,
  }),
  watch: {
    images: {
      deep: true,
      handler() {
        this.activeImage = this.images[0];
      },
    },
  },
  created() {
    if (this.images.length > 0) {
      this.activeImage = this.images[0];
    }
  },
};
</script>

<style scoped lang="sass">
.inactive-image
  opacity: 0.8
  cursor: pointer
</style>
